import { Component, OnInit, OnDestroy } from '@angular/core';
import { UIService, UserService } from 'services';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from 'models';

@Component({
	selector: 'app-navbar-kyg',
	template: require('./app-navbar-kyg.component.html'),
	styles: [require('./app-navbar-kyg.component.scss')],
	host: { class: 'flex flex-shrink-0' },
})
export class AppNavbarKygComponent implements OnInit, OnDestroy {
	public searchString: string;
	private userSectionSubscription: Subscription;
	public switchedFromAdmin$: Observable<boolean>;
	public user: User = new User();

	shareUrl: string;
	navbarOpen = true;

	constructor(public userService: UserService, public router: Router, public uiService: UIService) {}

	ngOnInit(): void {
		// checking if user switchedFromAdmin
		this.switchedFromAdmin$ = this.userService.userToken$.pipe(map(userToken => userToken.switchedFromAdmin || false));
	}

	ngOnDestroy() {
		if (this.userSectionSubscription) this.userSectionSubscription.unsubscribe();
	}

	toggleNavbar() {
		this.navbarOpen = !this.navbarOpen;
	}
}
